/**
 * <product-card-form> — botón de "agregar al carrito" en la tarjeta de
 * producto, solo para productos de una sola variante (sin selección
 * previa necesaria). Reutiliza el sistema de carrito de header.liquid:
 * dispara 'cart:items:refresh' (actualiza drawer/página) y 'cart:open'
 * (abre el drawer) después de agregar.
 */
class ProductCardForm extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-add-to-cart]');
    this.defaultLabel = this.button?.textContent.trim();
    this.button?.addEventListener('click', () => this.addToCart());
  }

  addToCart() {
    const variantId = this.dataset.variantId;
    if (!variantId || !this.button) return;

    this.button.disabled = true;
    this.button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('add-to-cart-failed');
        document.dispatchEvent(new CustomEvent('cart:items:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(() => {
        if (this.button) this.button.textContent = 'No se pudo agregar';
        window.setTimeout(() => {
          if (this.button && this.defaultLabel) this.button.textContent = this.defaultLabel;
        }, 2000);
      })
      .finally(() => {
        if (this.button) {
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
        }
      });
  }
}

customElements.define('product-card-form', ProductCardForm);